import React from 'react';
import { useEntityPageContext } from '../../providers';
import { observer } from 'mobx-react-lite';
import { CardContainer, CardContainerProps } from '../CardContainer';

export interface EntityPageCardProps extends CardContainerProps {}

export function _EntityPageCard(props: EntityPageCardProps) {
  const { status: statusProp, ...rest } = props;
  const pageState = useEntityPageContext();
  const status = !pageState || pageState.isFetching ? 'loading' : statusProp;

  return <CardContainer status={status} {...rest} />;
}

_EntityPageCard.displayName = 'EntityPageCard';

export const EntityPageCard = observer(_EntityPageCard);
